<template>
	<div class="live-commands">
		<div class="live-commands_row" v-for="(item, index) in lineup" :key="index">
			<div class="live-commands_col" v-if="item.home">
				<div class="live-commands_table">
					<div class="live-commands_1">{{ item.home.shirt_number ? item.home.shirt_number : '' }}</div>
					<div class="live-commands_2">{{ item.home.role }}</div>
					<div class="live-commands_3">
						<img :src="$hostname + '/img/country/' + item.home.country_code" alt="">
					</div>
					<div class="live-commands_4">
						{{ item.home.name }}
					</div>
				</div>
			</div>
			<div class="live-commands_col" v-if="item.away">
				<div class="live-commands_table">
					<div class="live-commands_1">{{ item.away.shirt_number ? item.away.shirt_number : '' }}</div>
					<div class="live-commands_2">{{ item.away.role }}</div>
					<div class="live-commands_3">
						<img :src="$hostname + '/img/country/' + item.away.country_code" alt="">
					</div>
					<div class="live-commands_4">
						{{ item.away.name }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['lineup'],
	}
</script>

<style scoped>

</style>